import { ClassroomStudent } from "@/types/models/Classroom.interface";

/**
 * Transforms a list of classroom students into a simplified format suitable for sidebar display
 *
 * @param studentList - Array of classroom student objects containing detailed student information
 * @returns Array of simplified student objects containing full name and ID
 * @example
 * const students = [{ user: { first_name: "John", last_name: "Doe" }, unique_id: "123", ... }];
 * const sidebarList = getClassroomStudentsList(students);
 * // Returns: [{ name: "John Doe", id: "123" }]
 */
const getClassroomStudentsList = (studentList: ClassroomStudent[]) => {
  return studentList.map((student) => {
    return {
      name: `${student.user.first_name} ${student.user.last_name}`,
      id: student.unique_id,
    };
  });
};

export default getClassroomStudentsList;
